"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  create: {
    id: "window.chracterShop.button.create",
    defaultMessage: "Create",
    description: ""
  },
  titleCanNotBeEmpty: {
    id: "window.chracterShop.notification.titleCanNotBeEmpty",
    defaultMessage: "Title can not be empty.",
    description: ""
  },
  atLeastOneItem: {
    id: "window.chracterShop.notification.atLeastOneItem",
    defaultMessage: "There must be at least one item.",
    description: ""
  }
});

exports.default = _default;